<template>
    <div class="consult-container">
        <ComDetail :detail="detail" :detailCols="detailCols" :onCancel="onCancel"></ComDetail>
        <div class="search-container">
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="应用名称">
                    <el-input v-model="formInline.appName" placeholder="请输入应用名称"></el-input>
                </el-form-item>
                <el-form-item label="应用类型">
                    <el-select v-model="formInline.type" placeholder="请选择" clearable>
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table-container">
            <el-table v-loading="tableLoading" :data="tableData" :pagination="pagination" border style="width: 100%">
                <el-table-column prop="appName" label="应用名称" align="center">
                </el-table-column>
                <el-table-column prop="memberName" label="申请用户" align="center">
                </el-table-column>
                <el-table-column prop="createDate" label="申请时间" align="center" :formatter="dateFormat">
                </el-table-column>
                <el-table-column prop="appType" align="center" label="应用类型">
                </el-table-column>
                <el-table-column prop="reviewStatus" align="center" label="审核状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.reviewStatus === 0">未通过</span>
                        <span v-else-if="scope.row.reviewStatus === 2">待审核</span>
                        <span v-else-if="scope.row.reviewStatus === 3">审核通过</span>
                        <span v-else>未知状态</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="100">
                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                        <el-button v-if="scope.row.reviewStatus === 2" type="text" size="small"
                            @click="handleReplyClick(scope.row)">审核</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 40]"
                    :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.total">
                </el-pagination>
            </div>
        </div>
        <!-- 审核功能 -->
        <el-drawer title="审核" :visible.sync="drawer" direction="rtl" :before-close="handleClose">
            <el-form ref="form" :model="drawerForm" label-width="80px">
                <el-form-item label="审核结果">
                    <el-radio-group v-model="drawerForm.result">
                        <el-radio :label="0">通过</el-radio>
                        <el-radio :label="1">不通过</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="应用链接" v-if="drawerForm.result === 0">
                    <el-input v-model="drawerForm.appUrl" placeholder="请输入应用链接"></el-input>
                </el-form-item>
                <el-form-item label="原因" v-if="drawerForm.result === 1">
                    <el-input rows="4" type="textarea" v-model="drawerForm.reason" placeholder="请输入原因"></el-input>
                </el-form-item>
            </el-form>
            <div class="drawer-footer">
                <el-button @click="cancelForm">取 消</el-button>
                <el-button type="primary" @click="submitReview" :loading="loading">{{ loading ? '提交中 ...' : '确 定'
                    }}</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import { appTypeDict2 } from '@/data/constant'
import { getAppUploadAuditList, getAppUploadAudit } from '@/api/SupermarketOperation'
import moment from "moment";
import ComDetail from '@/components/common/comDetail.vue';
export default {
    name: 'AdminStaticsApplication',
    components: {
        ComDetail
    },
    data() {
        return {
            tableLoading: false,
            detail: {
                visible: false,
                record: {},
            },
            detailCols: [
                {
                    label: '应用名称',
                    prop: 'appName'
                },
                {
                    label: '申请用户',
                    prop: 'memberName'
                },
                {
                    label: '申请时间',
                    prop: 'createDate',
                    formatter: (row) => moment(row.createDate).format('YYYY-MM-DD HH:mm:ss'),
                },
                {
                    label: '应用类型',
                    prop: 'appType',
                },

            ],
            options: appTypeDict2,
            drawer: false,
            formInline: {
                type: ''
            },
            pagination: {
                currentPage: 1, // 当前页
                pageSize: 10, // 每页显示条数
                total: 0, // 总条数
                layout: 'total, prev, pager, next, jumper', // 分页布局
            },
            tableData: [],
            drawerForm: {
                result: 0,
                reason: '',
                appUrl: ''
            },
            record: {},
            pageObj: {
                pageNo: 0,
                pageSize: 10
            }
        };
    },

    mounted() {
        this.loadData()
    },
    methods: {
        // 查看
        onCancel() {
            this.detail.visible = false
        },
        cancelForm() {
            this.drawer = false
        },
        async submitReview() {
            const params = {
                result: this.drawerForm.result
            }
            if (this.drawerForm.result === 1) {
                params.reason = this.drawerForm.reason
            } else {
                params.appUrl = this.drawerForm.appUrl
            }
            await getAppUploadAudit({
                appId: this.record.id,
                memberId: this.record.memberId,
                ...params,
            }).then(() => {
                this.$message.success('审核成功')
                this.drawer = false
                this.record = {}
                this.loadData()
            })
        },
        // 时间转换
        dateFormat(row) {
            return moment(row.createDate).format('YYYY-MM-DD HH:mm:ss');
        },
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.loadData()
        },
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.pageObj.currentPage = val - 1
            this.loadData()
        },
        handleClick(row) {
            this.detail.visible = true
            this.detail.record = row
        },
        handleReplyClick(row) {
            this.drawer = true
            this.record = row
        },
        onSubmit() {

            this.pageObj.type = Number(this.formInline.type)

            this.loadData()
        },
        async loadData() {
            this.tableLoading = true
            const params = {
                dataType: 4,
            }
            await getAppUploadAuditList({ ...this.pageObj, ...params }).then(res => {
                this.tableLoading = false
                this.tableData = res.data.content
                this.pagination.total = res.data.totalElements
            })
        }
    },
};
</script>
<style lang="scss" scoped>
.consult-container {
    background: #fff;
    padding: 24px 0;

    .search-container {
        padding: 0 16px;
        border-bottom: 1px solid #EBEEF5;
    }

    .table-container {
        padding: 16px;
    }

    .pagination-container {
        margin-top: 16px;
        text-align: right;
    }

    .drawer-footer {
        text-align: center;
    }
}

::v-deep .el-drawer__body {
    padding: 0 16px;
}
</style>